var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#EDEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9885 9.16675C15.0085 9.16675 10.166 14.0201 10.166 20.0001C10.166 25.9801 15.0085 30.8334 20.9885 30.8334C26.9793 30.8334 31.8327 25.9801 31.8327 20.0001C31.8327 14.0201 26.9793 9.16675 20.9885 9.16675ZM25.6035 24.4959L19.916 21.0834V14.5834H21.541V20.2709L26.416 23.1634L25.6035 24.4959Z",
    fill: "#8E8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.14542ef071dca01740be48652b3c24d1.svg";
export { ForwardRef as ReactComponent };